/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import { ROOT_SLICE } from '../constants';
import { toTimeuuids, forceArray } from '../util';

const { 
	addIsSyncing, 
	removeIsSyncing, 
	clearIsSyncing,
	
	addIsUnsyncing, 
	removeIsUnsyncing, 
	clearIsUnsyncing,

	addIsDeleting, 
	removeIsDeleting, 
	clearIsDeleting,
	
	addIsQueuedForDelete, 
	removeIsQueuedForDelete, 
	clearIsQueuedForDelete,
	
	addIsSelected, 
	removeIsSelected, 
	clearIsSelected,

	addErrorMessages,
	removeErrorMessages,
	clearErrorMessages,
	
	clear,
 } = createActions(
	{
		ADD_IS_SYNCING: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		REMOVE_IS_SYNCING: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		CLEAR_IS_SYNCING: () => ({}),



		ADD_IS_UNSYNCING: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		REMOVE_IS_UNSYNCING: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		CLEAR_IS_UNSYNCING: () => ({}),



		ADD_IS_DELETING: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		REMOVE_IS_DELETING: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		CLEAR_IS_DELETING: () => ({}),



		ADD_IS_QUEUED_FOR_DELETE: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		REMOVE_IS_QUEUED_FOR_DELETE: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		CLEAR_IS_QUEUED_FOR_DELETE: () => ({}),



		ADD_IS_SELECTED: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		REMOVE_IS_SELECTED: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		CLEAR_IS_SELECTED: () => ({}),



		ADD_ERROR_MESSAGES: (surveys, messages) => ({ 
			timeuuids: toTimeuuids(surveys), 
			messages: forceArray(messages) 
		}),
		REMOVE_ERROR_MESSAGES: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		CLEAR_ERROR_MESSAGES: () => ({}),



		CLEAR: () => ({}),
	},
	{ prefix: ROOT_SLICE }
);

export { 
	addIsSyncing, 
	removeIsSyncing, 
	clearIsSyncing,
	
	addIsUnsyncing, 
	removeIsUnsyncing, 
	clearIsUnsyncing,
	
	addIsDeleting, 
	removeIsDeleting, 
	clearIsDeleting,
		
	addIsQueuedForDelete, 
	removeIsQueuedForDelete, 
	clearIsQueuedForDelete,

	addIsSelected, 
	removeIsSelected, 
	clearIsSelected,

	addErrorMessages,
	removeErrorMessages,
	clearErrorMessages,
	
	clear,
};
